var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5123 12.1087C16.5123 11.9087 16.5123 11.6087 16.4163 11.4087L11.4243 16.7087C11.6163 16.7087 11.9043 16.8087 12.0963 16.8087C14.4963 16.8087 16.5123 14.7087 16.5123 12.1087Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58447 12.1087C7.58447 12.3087 7.58447 12.6087 7.68047 12.8087L12.7685 7.50869C12.5765 7.50869 12.2885 7.40869 12.0965 7.40869C9.60047 7.40869 7.58447 9.50869 7.58447 12.1087Z",
    fill: "#CECECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6958 12.1086C19.3918 15.5086 15.9358 17.3086 11.9998 17.3086C11.6158 17.3086 11.2318 17.3086 10.8478 17.2086L9.21582 19.0086C10.1758 19.2086 11.1358 19.3086 12.0958 19.3086C16.8958 19.3086 21.0238 16.9086 23.7118 12.6086L24.0958 12.1086L23.7118 11.6086C22.7518 10.0086 21.5038 8.70864 20.1598 7.60864L18.8158 9.00864C19.8718 9.90864 20.8318 10.9086 21.6958 12.1086Z",
    fill: "#CECECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 12.1088C4.704 8.70879 8.16 6.90879 12.096 6.90879C12.48 6.90879 12.864 6.90879 13.248 7.00879L14.88 5.30879C13.92 5.10879 12.96 5.00879 12 5.00879C7.2 5.00879 3.072 7.40879 0.384001 11.7088L0 12.2088L0.384001 12.7088C1.344 14.3088 2.592 15.6088 3.936 16.7088L5.28 15.3088C4.224 14.4088 3.264 13.4088 2.4 12.1088Z",
    fill: "#CECECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0254 1.41579L1.73613 23.4953L1.07299 22.8015L22.3623 0.721987L23.0254 1.41579Z",
    stroke: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHidden);
export default __webpack_public_path__ + "static/media/password-hidden.1a0e5d1a959470511d0ea25277daff50.svg";
export { ForwardRef as ReactComponent };